import React from "react";
import { useAppSelector } from "../../app/hooks";
import { useTranslation } from "react-i18next";
import DepartIcon from "../../images/custom/SFO/vector-depart.svg";
import MapIcon from "../../images/custom/SFO/icon-map.svg";
import SettingsIcon from "../../images/custom/SFO/icon-setting.svg";
import SearchFlightsResultsSFO from "./results/SFO/SearchFlightsResultsSFO";
import SearchFlightsFormSFO from "./form/custom/SFO/SearchFlightsFormSFO";
import SearchFlightsResultsButtonsSFO from "./results/SFO/SearchFlightsResultsButtonsSFO";

function SearchFlightsSFO({ layout }) {
  const formDisabled = useAppSelector(
    (state) => state.searchFlights.form.disabled
  );

  const hasResults = useAppSelector(
    (state) => state.searchFlights.results.hasResults
  );

  return (
    <>
      <SearchFlightsFormSFO />
      <ResultsLoading />
      <div className="block is-flex-grow-2">
        {formDisabled && hasResults && (
          <div className="is-flex is-flex-direction-column">
            <SearchFlightsResultsButtonsSFO />
            <SearchFlightsResultsSFO layout={layout} />
          </div>
        )}
        <NoResultsNotification />
      </div>
    </>
  );
}

function ResultsLoading() {
  const loading = useAppSelector(
    (state) => state.searchFlights.results.loading
  );
  const direction = useAppSelector(
    (state) => state.searchFlights.results.direction
  );
  const type = useAppSelector((state) => state.searchFlights.results.type);

  if (loading && direction === "" && type === "") {
    return <progress className="progress mt-2" />;
  } else {
    return null;
  }
}

function NoResultsNotification() {
  const { t } = useTranslation();

  const loading = useAppSelector(
    (state) => state.searchFlights.results.loading
  );
  const formDisabled = useAppSelector(
    (state) => state.searchFlights.form.disabled
  );
  const hasResults = useAppSelector(
    (state) => state.searchFlights.results.hasResults
  );

  if (formDisabled && !hasResults && !loading) {
    return (
      <div className="notification columns is-vcentered m-1 is-flex-direction-column">
        <div className="column is-half is-justify-content-center">
          <h2 className="no-found-flight-title has-text-weight-bold">
            {t("SFO_LABEL_NO_FLIGHTS_FOUND")}
          </h2>
          <p className="no-found-flight-detail">
            {t("SFO_LABEL_NO_FLIGHTS_FOUND_DETAIL")}
          </p>
        </div>
        <div className="column">
          <div className="columns is-justify-content-center">
            <div className="column is-one-fifth no-found-item">
              <img src={DepartIcon} alt="depart" />
              <p>{t("NO_FOUND_DEPART_DETAIL")}</p>
            </div>
            <div className="column is-one-fifth no-found-item">
              <img src={MapIcon} alt="map" />
              <p>{t("NO_FOUND_MAP_DETAIL")}</p>
            </div>
            <div className="column is-one-fifth no-found-item">
              <img src={SettingsIcon} alt="map" />
              <p>{t("NO_FOUND_SETTING_DETAIL")}</p>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default SearchFlightsSFO;
